'use strict';
const { createCanvas } = require('canvas');
const jwt = require('jwt-simple');
export default {
  methods: {
    getRandomInt (min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    makeText () {
      return new Promise((resolve, reject) => {
        try {
          let token = '';
          let decoded = '';
          this.$service.get('captcha').then(response => {
            token = response;
            decoded = jwt.decode(token, '', true);
            resolve({
              error_existente: 0,
              captcha: decoded.captcha,
              token
            });
          }).catch(error => {
            console.log(error);
          });
        } catch (error) {
          reject(new Error({
            error_existente: 1,
            error_mensaje: 'Captcha Expiro'
          }));
        }
      });
    },
    generateCaptcha (value) {
      const colors = ['#2280b6', '#c31a1a', '#df8a0f', '#b5c109', '#51c109', '#51c109', '#0e465e', '#1c3b88', '#5a1c88', '#881c7e', '#881c3e', '#881c1c', '#6a6780', '#0dcb47'];
      const canvas = createCanvas(200, 90);
      const ctx = canvas.getContext('2d');
      ctx.font = '40px Impact';
      ctx.rotate(0.3);
      ctx.fillText(value, this.getRandomInt(18, 25), this.getRandomInt(25, 35));
      ctx.strokeStyle = colors[this.getRandomInt(0, colors.length - 1)];
      ctx.beginPath();
      ctx.moveTo(this.getRandomInt(115, 125), (-1) * this.getRandomInt(5, 15));
      ctx.lineTo(this.getRandomInt(80, 145), this.getRandomInt(25, 50));
      ctx.moveTo(this.getRandomInt(10, 30), this.getRandomInt(1, 15));
      ctx.bezierCurveTo(1, 80, 50, 20, this.getRandomInt(80, 125), (-1) * this.getRandomInt(30, 50));
      ctx.moveTo(this.getRandomInt(110, 140), this.getRandomInt(0, 10));
      ctx.bezierCurveTo(150, 20, 60, 20, this.getRandomInt(0, 15), this.getRandomInt(30, 45));
      ctx.moveTo(this.getRandomInt(5, 10), this.getRandomInt(15, 35));
      ctx.bezierCurveTo(8, 15, 25, 100, this.getRandomInt(90, 110), this.getRandomInt(0, 10));
      ctx.lineWidth = 2;
      // lines
      ctx.stroke();
      let base64 = canvas.toDataURL();
      return base64;
    },
    verificarCaptcha (useCaptcha, textCaptcha, responseCaptcha) {
      if (useCaptcha) {
        if (textCaptcha.toUpperCase() === responseCaptcha.toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
        return !useCaptcha;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/portal/mixins/captcha.js